export const iPhoneModels = [
  {
    gpu: "a17",
    viewports: {
      "1179x2556": {
        devicePixelRatios: {
          "3": { models: ["iPhone 15 Pro"] },
        },
      },
      "1290x2796": {
        devicePixelRatios: {
          "3": { models: ["iPhone 15 Pro Max"] },
        },
      },
    },
  },
  {
    gpu: "a16",
    viewports: {
      "1179x2556": {
        devicePixelRatios: {
          "3": { models: ["iPhone 14 Pro"] },
        },
      },
      "1290x2796": {
        devicePixelRatios: {
          "3": { models: ["iPhone 14 Pro Max"] },
        },
      },
    },
  },
  {
    gpu: "a15",
    viewports: {
      "1170x2532": {
        devicePixelRatios: {
          "3": { models: ["iPhone 13", "iPhone 13 Pro", "iPhone 14"] },
        },
      },
      "1080x2340": {
        devicePixelRatios: {
          "3": { models: ["iPhone 13 mini"] },
        },
      },
      "1284x2778": {
        devicePixelRatios: {
          "3": { models: ["iPhone 13 Pro Max", "iPhone 14 Plus"] },
        },
      },
    },
  },
  {
    gpu: "a14",
    viewports: {
      "1170x2532": {
        devicePixelRatios: {
          "3": { models: ["iPhone 12", "iPhone 12 Pro"] },
        },
      },
      "1080x2340": {
        devicePixelRatios: {
          "3": { models: ["iPhone 12 mini"] },
        },
      },
      "1284x2778": {
        devicePixelRatios: {
          "3": { models: ["iPhone 12 Pro Max"] },
        },
      },
    },
  },
  {
    gpu: "a13",
    viewports: {
      "828x1792": {
        devicePixelRatios: {
          "2": { models: ["iPhone 11"] },
        },
      },
      "1125x2436": {
        devicePixelRatios: {
          "3": { models: ["iPhone 11 Pro"] },
        },
      },
      "1242x2688": {
        devicePixelRatios: {
          "3": { models: ["iPhone 11 Pro Max"] },
        },
      },
    },
  },
  {
    gpu: "a12",
    viewports: {
      "1125x2436": {
        devicePixelRatios: {
          "3": { models: ["iPhone XS"] },
        },
      },
      "1242x2688": {
        devicePixelRatios: {
          "3": { models: ["iPhone XS Max"] },
        },
      },
      "828x1792": {
        devicePixelRatios: {
          "2": { models: ["iPhone XR"] },
        },
      },
    },
  },
  {
    gpu: "a11",
    viewports: {
      "1125x2436": {
        devicePixelRatios: {
          "3": { models: ["iPhone X"] },
        },
      },
      "750x1334": {
        devicePixelRatios: {
          "2": { models: ["iPhone 8"] },
        },
      },
      "1080x1920": {
        devicePixelRatios: {
          "3": { models: ["iPhone 8 Plus"] },
        },
      },
    },
  },
] as const;
